/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProfileAnalyticsTermItem } from '../../models/profile-analytics-term-item';

export interface ProfileFollowersTypeHistogram$Params {
  id: number;
  type: 'follow-type' | 'area-of-expertize' | 'country' | 'gender' | 'birth-year';
}

export function profileFollowersTypeHistogram(http: HttpClient, rootUrl: string, params: ProfileFollowersTypeHistogram$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileAnalyticsTermItem>>> {
  const rb = new RequestBuilder(rootUrl, profileFollowersTypeHistogram.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('type', params.type, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ProfileAnalyticsTermItem>>;
    })
  );
}

profileFollowersTypeHistogram.PATH = '/analytics/profile/{id}/followers/type-histogram/{type}';
